import { BrowserAnalytics } from '@remento/web-analytics-client/analytics.browser';

import { Payload, Router } from '../../router.js';

import { ClickEvent, ClickPayload } from './@types.js';

export function registerClickHandler(router: Router, analytics: BrowserAnalytics) {
  const logger = router.logger.extend('click-handler');
  router.registerHandler('click-handler', (event, payload) => {
    switch (event) {
      case ClickEvent: {
        const clickPayload = payload as Payload<ClickPayload>;
        logger.debug('CLICK_EVENT', () => ({ type: event, payload }));
        analytics.track(clickPayload.data.event, { ...payload.properties });
        return true;
      }
    }
    return false;
  });
}
